@if (structure) {
  <div class="bg-white p-xl-5 p-2">
    <div class="border-bottom border-gray">
      <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
      @if (isModificationMode) {
        <h3 class="text-end text-secondary pb-2">Consultation de la structure {{ structure.label || '' }}</h3>
      }
      @if (!isModificationMode) {
        <h3 class="text-end text-secondary pb-2">Création d'une structure</h3>
      }
    </div>
    <div class="container-fluid px-0">
      <ul class="nav-tabs nav-fill" ngbNav #nav="ngbNav" (navChange)="onNavChange($event)" [activeId]="activeTabId" [destroyOnHide]="false">
        <li [ngbNavItem]="'global'">
          <a ngbNavLink><h5 class="text-secondary">Général</h5></a>
          <ng-template ngbNavContent>
            <app-structure-global [structure]="structure"> </app-structure-global>
          </ng-template>
        </li>
        <li [ngbNavItem]="'address'">
          <a ngbNavLink><h5 class="text-secondary">Adresse</h5></a>
          <ng-template ngbNavContent>
            <app-structure-address [structure]="structure"> </app-structure-address>
          </ng-template>
        </li>
        <li [ngbNavItem]="'support-places'">
          <a ngbNavLink><h5 class="text-secondary">Places d'accompagnement</h5></a>
          <ng-template ngbNavContent>
            <app-structure-support-places [structure]="structure"> </app-structure-support-places>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
    @if (
      submitted &&
      !(
      structureDetailAddress?.mainAddressForm.valid &&
      structureDetailGlobal?.structureGlobalForm.valid &&
      structureDetailSupportPlace?.places.form.valid
      )
      ) {
      <small
        class="form-text text-danger"
        >Certains champs obligatoires ne sont pas renseignés</small
        >
      }
      <div class="row px-3">
        <div class="col-3 d-md-none d-lg-block col-lg-6 mb-1"></div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="submit" (click)="onSubmit()">
            <fa-icon icon="save"></fa-icon>
            <span class="ms-3 d-none d-md-block">Sauvegarder</span>
          </button>
        </div>
      </div>
    </div>
  }
